import { render, staticRenderFns } from "./teamRegister.vue?vue&type=template&id=1165e81a&scoped=true&"
import script from "./teamRegister.vue?vue&type=script&lang=js&"
export * from "./teamRegister.vue?vue&type=script&lang=js&"
import style0 from "./teamRegister.vue?vue&type=style&index=0&id=1165e81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165e81a",
  null
  
)

export default component.exports